import { Global } from '@emotion/react';
import * as React from 'react';
import { css } from '../styled-system';
import { createContext, memoisedGet as get, runIfFn } from '../utils';
export { ThemeProvider } from '@emotion/react';
export { StylesProvider, useStyles };
var [StylesProvider, useStyles] = createContext({
  name: 'StylesContext',
  errorMessage: 'useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` '
});

/**
 * Applies styles defined in `theme.styles.global` globally
 * using emotion's `Global` component
 */
export var GlobalStyle = () => {
  return /*#__PURE__*/React.createElement(Global, {
    styles: theme => {
      var styleObjectOrFn = get(theme, 'styles.global');
      var globalStyles = runIfFn(styleObjectOrFn, {
        theme
      });
      if (!globalStyles) return undefined;
      var styles = css(globalStyles)(theme);
      return styles;
    }
  });
};